import StatusHistogram from './StatusHistogram';
import MetricTile from './MetricTile';
import ClosedOutcomeBreakdown from './ClosedOutcomeBreakdown';
import '../../styles/CaseListMetrics.css';

function CaseListMetrics({ metrics, loading }) {
    if (loading) {
        return (
            <div
                className="case-list-metrics case-list-metrics--skeleton"
                data-testid="case-list-metrics-skeleton"
                aria-busy="true"
            >
                <div className="case-list-metrics__card case-list-metrics__skeleton-card" />
                <div className="case-list-metrics__card case-list-metrics__skeleton-card" />
                <div className="case-list-metrics__card case-list-metrics__skeleton-card" />
            </div>
        );
    }

    const {
        histogram,
        avgOpenAgeDays,
        totalClosed,
        activeCount,
        approvalRatePct,
        avgTimeToCloseDays,
    } = metrics;

    if (activeCount === 0 && totalClosed === 0) {
        return null;
    }

    return (
        <div className="case-list-metrics">
            <StatusHistogram histogram={histogram} activeCount={activeCount} />
            <MetricTile
                label="Avg open age"
                value={avgOpenAgeDays}
                suffix=" days"
            />
            <ClosedOutcomeBreakdown
                totalClosed={totalClosed}
                approvalRatePct={approvalRatePct}
                avgTimeToCloseDays={avgTimeToCloseDays}
            />
        </div>
    );
}

export default CaseListMetrics;
